var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#photo_svg__clip0_22452_50518)",
    fill: "#EC6338"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4h-.508l-2.184-2.832A3.024 3.024 0 0013.932 0h-3.864a3.023 3.023 0 00-2.376 1.168L5.508 4H5a5.006 5.006 0 00-5 5v10a5.006 5.006 0 005 5h14a5.006 5.006 0 005-5V9a5.006 5.006 0 00-5-5zM9.276 2.39a1.006 1.006 0 01.792-.39h3.864a1.008 1.008 0 01.792.39L15.966 4H8.034l1.242-1.61zM22 19a3 3 0 01-3 3H5a3 3 0 01-3-3V9a3 3 0 013-3h14a3 3 0 013 3v10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8a6 6 0 100 12 6 6 0 000-12zm0 10a4 4 0 110-8 4 4 0 010 8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "photo_svg__clip0_22452_50518"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgPhoto;